module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-4-306e618ab16bc72356140a0419fedc88.svg";